module.exports = __webpack_public_path__ + "img/logo_hr.e5525991.webp";